import React, {useState} from 'react';
import PropTypes from 'prop-types';
import RegisterView from '../components/RegisterView';

const Register = props => {
  const {register} = props;

  const [isRegistered, setIsRegistered] = useState(false);

  const onSubmit = async values => {
    try {
      await register(values);
      setIsRegistered(true);
    } catch (e) {
      throw new Error(e);
    }
  };

  return (
    <div className="public-layout">
      <div className="login-layout">
        <RegisterView {...props} isRegistered={isRegistered} onSubmit={onSubmit} />
      </div>
    </div>
  );
};

Register.propTypes = {
  history: PropTypes.object,
  navigation: PropTypes.object,
};

export default Register;
